import { ZodiacSign } from '@/api/consts'
import AquariusSvg from '@/app/icons/signs/aquarius.svg?react'
import AriesSvg from '@/app/icons/signs/aries.svg?react'
import CancerSvg from '@/app/icons/signs/cancer.svg?react'
import CapricornSvg from '@/app/icons/signs/capricorn.svg?react'
import GeminiSvg from '@/app/icons/signs/gemini.svg?react'
import LeoSvg from '@/app/icons/signs/leo.svg?react'
import LibraSvg from '@/app/icons/signs/libra.svg?react'
import PiscesSvg from '@/app/icons/signs/pisces.svg?react'
import SagittariusSvg from '@/app/icons/signs/sagittarius.svg?react'
import ScorpioSvg from '@/app/icons/signs/scorpio.svg?react'
import TaurusSvg from '@/app/icons/signs/taurus.svg?react'
import VirgoSvg from '@/app/icons/signs/virgo.svg?react'
import type { FunctionalComponent } from 'preact'

export const Sign: FunctionalComponent<{
  sign: ZodiacSign
  class?: string
}> = props => {
  switch (props.sign) {
    case ZodiacSign.ARIES:
      return <AriesSvg class={props.class} />
    case ZodiacSign.TAURUS:
      return <TaurusSvg class={props.class} />
    case ZodiacSign.GEMINI:
      return <GeminiSvg class={props.class} />
    case ZodiacSign.CANCER:
      return <CancerSvg class={props.class} />
    case ZodiacSign.LEO:
      return <LeoSvg class={props.class} />
    case ZodiacSign.VIRGO:
      return <VirgoSvg class={props.class} />
    case ZodiacSign.LIBRA:
      return <LibraSvg class={props.class} />
    case ZodiacSign.SCORPIO:
      return <ScorpioSvg class={props.class} />
    case ZodiacSign.SAGITTARIUS:
      return <SagittariusSvg class={props.class} />
    case ZodiacSign.CAPRICORN:
      return <CapricornSvg class={props.class} />
    case ZodiacSign.AQUARIUS:
      return <AquariusSvg class={props.class} />
    case ZodiacSign.PISCES:
      return <PiscesSvg class={props.class} />
    default:
      return null
  }
}
